import React from 'react';
import { Form, Input, Col, Row } from 'antd';

const ValidationErrors = {
  required: (field: string) => `${field} is required.`,
};

const UserNameForm: React.FC = React.memo(() => {
  return (
    <Row gutter={[8, 16]}>
      <Col span={24}>
        <Form.Item
          name="firstName"
          label="Name*"
          rules={[{ required: true, message: ValidationErrors.required('Name') }]}
        >
          <Input size="large" />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          name="lastName"
          label="Surname*"
          rules={[{ required: true, message: ValidationErrors.required('Surname') }]}
        >
          <Input size="large" />
        </Form.Item>
      </Col>
    </Row>
  );
});

export default UserNameForm;
